import { useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

const Search = () => {
  const navigate = useNavigate();
  const [query, setQuery] = useState("");
  const inputRef = useRef(null);

  const searchProduct = (event) => {
    if (!query) return;
    navigate('/product/' + query);
  };
  
  const handleEnter = (event) => {
    if (event.key === 'Enter') {
      searchProduct();
    }
  };

  const logout = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    navigate('/');
    window.location.reload();
  };

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  return (
    <div className="container">
      <div className="logout">
        <Link className="nav" to="/products">INVENTORY LIST</Link>
        <button className="logout_btn" onClick={logout}>LOGOUT</button>
      </div>
      <br />
      <div className="search">
        <input 
          type="text"
          ref={inputRef}
          onChange={(e) => setQuery(e.target.value)}
          onKeyUp={handleEnter}
        />
        <button onClick={searchProduct}>SEARCH PRODUCT</button>
      </div>
    </div>
  );
};

export default Search;
